import { render, staticRenderFns } from "./Match.vue?vue&type=template&id=06610673&scoped=true&"
import script from "./Match.vue?vue&type=script&lang=js&"
export * from "./Match.vue?vue&type=script&lang=js&"
import style0 from "./Match.vue?vue&type=style&index=0&id=06610673&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06610673",
  null
  
)

export default component.exports